import { combineEpics } from 'redux-observable';

import { createFileReferenceEpic } from './CreateFileReference/CreateFileReferenceEpic';
import { deleteFileReferenceEpic } from './DeleteFileReference/DeleteFileReferenceEpic';
import { findFileReferencesEpic }  from './FindFileReferences/FindFileReferencesEpic';
import { findFileReferenceEpic }    from './FindFileReference/FindFileReferenceEpic';
import { searchFileReferencesEpic } from './SearchFileReferences/SearchFileReferencesEpic';
import { updateFileReferenceEpic }  from './UpdateFileReference/UpdateFileReferenceEpic';


export default combineEpics(
    createFileReferenceEpic,
    deleteFileReferenceEpic,
    findFileReferencesEpic,
    findFileReferenceEpic,
    searchFileReferencesEpic,
    updateFileReferenceEpic,
);
